import { CmProAuthService } from "./cmpro-auth.service";

// AkitaAuthService intentionally excluded from barrel —
// it imports GlobalsService which imports this barrel, creating a circular dep.
// Inject AkitaAuthService directly from its file path where needed.
export const services = [
  CmProAuthService,
];

export * from "./cmpro-auth.service";
